import {Alert} from 'bootstrap';
$(document).ready(() => {
    $('div.alert-flash').not('.alert-important').each(function() {
        let el = this;
        window.setTimeout(() => {
            (new Alert(el)).close()
        }, $(el).data('timeout') || 3000);
    });
});
